import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme, Typography } from '@mui/material';

const DetectionColumn: FC<
  React.PropsWithChildren<DetectionColumnProps>
> = props => {
  const { classes } = useStyles();
  const { header, children, width = '25%' } = props;
  return (
    <div style={{ width }} className={classes.detectionColumn}>
      <Typography variant='body2' fontWeight={400} color='text.secondary'>
        {header}
      </Typography>
      {children}
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  detectionColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

export interface DetectionColumnProps {
  header: string;
  width?: string;
}

export default DetectionColumn;
